import Modal from 'react-native-modal';
import {
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import Colors from '../../constants/Colors';
import CloseModalIcon from '../CloseModalIcon';
import TickIcon from '../TickIcon';
import CloseIconSmall from '../12pxIcons/CloseIconSmall';
import { UserPermission } from '../../constants/Types';

export default function RoleModal(props) {
  const HasPermission = ({ permission }) => (
    <View style={{
      width: 20,
      height: 20,
      borderRadius: 10,
      justifyContent: 'center',
      alignItems: 'flex-start',
      flex: 1,
    }}>
      {(props.permissions?.includes(permission)
      || props.isAdmin) ? <TickIcon /> : <CloseIconSmall />}
    </View>
  );

  const ColumnHeader = ({ text, flex = 1 }) => (
    <Text style={{
      fontSize: 10,
      marginBottom: 10,
      flex: flex || 1,
      fontFamily: 'Roboto_500Medium',
      color: Colors.light.hereworksBlack400,
    }}>{text}</Text>
  );

  return (
    <Modal
      isVisible={props.isVisible}
      onBackdropPress={() => props.setModalVisible(false)}
      >
        <View style={{
          flex: 1, backgroundColor: 'white', borderRadius: 10, padding: 20,
        }}>
          <View style={{ flexDirection: 'row' }}>
            <Text style={{
              fontSize: 18,
              fontWeight: 'bold',
              marginBottom: 20,
              textAlign: 'center',
              flex: 1,
              marginTop: 30,
            }}>{props.title}</Text>
            <Pressable
              onPress={() => props.setModalVisible(false)}
              style={{
                marginTop: 20,
                padding: 10,
                backgroundColor: Colors.light.hereworksBlue100,
                width: 40,
                height: 40,
                borderRadius: 20,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <CloseModalIcon />
            </Pressable>
          </View>
          <View style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <ColumnHeader text="PERMISSIONS" flex={2} />
            <ColumnHeader text="CREATE" />
            <ColumnHeader text="VIEW" />
            <ColumnHeader text="EDIT" />
            <ColumnHeader text="DELETE" />
          </View>
          <View style={styles.row}>
            <Text style={styles.rowTitle}>Tickets</Text>
            <HasPermission permission={UserPermission.TICKETS_CREATE} />
            <HasPermission permission={UserPermission.TICKETS_READ} />
            <HasPermission permission={UserPermission.TICKETS_UPDATE} />
            <HasPermission permission={UserPermission.TICKETS_DELETE} />
          </View>
          <View style={styles.row}>
            <Text style={styles.rowTitle}>Templates</Text>
            <HasPermission permission={UserPermission.TEMPLATES_CREATE} />
            <HasPermission permission={UserPermission.TEMPLATES_READ} />
            <HasPermission permission={UserPermission.TEMPLATES_UPDATE} />
            <HasPermission permission={UserPermission.TEMPLATES_DELETE} />
          </View>
          <View style={styles.row}>
            <Text style={styles.rowTitle}>Assets</Text>
            <HasPermission permission={UserPermission.ASSETS_CREATE} />
            <HasPermission permission={UserPermission.ASSETS_READ} />
            <HasPermission permission={UserPermission.ASSETS_UPDATE} />
            <HasPermission permission={UserPermission.ASSETS_DELETE} />
          </View>
          <View style={styles.row}>
            <Text style={styles.rowTitle}>User Groups</Text>
            <HasPermission permission={UserPermission.USER_GROUPS_CREATE} />
            <HasPermission permission={UserPermission.USER_GROUPS_READ} />
            <HasPermission permission={UserPermission.USER_GROUPS_UPDATE} />
            <HasPermission permission={UserPermission.USER_GROUPS_DELETE} />
          </View>
          <View style={styles.row}>
            <Text style={styles.rowTitle}>Users</Text>
            <HasPermission permission={UserPermission.USERS_CREATE} />
            <HasPermission permission={UserPermission.USERS_READ} />
            <HasPermission permission={UserPermission.USERS_UPDATE} />
            <HasPermission permission={UserPermission.USERS_DELETE} />
          </View>
          <View style={styles.row}>
            <Text style={styles.rowTitle}>Locations</Text>
            <HasPermission permission={UserPermission.LOCATIONS_CREATE} />
            <HasPermission permission={UserPermission.LOCATIONS_READ} />
            <HasPermission permission={UserPermission.LOCATIONS_UPDATE} />
            <HasPermission permission={UserPermission.LOCATIONS_DELETE} />
          </View>
        </View>
      </Modal>);
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginVertical: 12,
    borderColor: Colors.light.hereworksBlue100,
  },
  rowTitle: {
    fontSize: 14,
    marginBottom: 10,
    flex: 2,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
  },
});
